module.exports = "https://web-assets.ifttt.com/packs/media/prosumer/svg--counting-d7d7a0e8.svg";